import { EXPORT_TYPES } from 'dynamo-daos/build/models/exports/exportRecord';

import { type DefaultExportSettings } from '../types';

const EXPORT_TYPE_VALUES = new Set<string>(Object.values(EXPORT_TYPES));

/** Account `exportType` (`FBX-ROBLOX` or `FBX_ROBLOX`) → backend `EXPORT_TYPES`. */
export function parseDefaultExportType(
  exportType: DefaultExportSettings['exportType'] | string | undefined,
): EXPORT_TYPES | undefined {
  const normalized = String(exportType ?? '')
    .trim()
    .toUpperCase()
    .replace(/_/g, '-');
  if (!EXPORT_TYPE_VALUES.has(normalized)) {
    return undefined;
  }
  return normalized as EXPORT_TYPES;
}
